// extracted by mini-css-extract-plugin
module.exports = {"goals":"styles_goals__1Zs85","goals__wrap":"styles_goals__wrap__v0LNg"};